import { precisionRound } from "@/mixins/precision-round";

export default {
	state: {
		active: false,
		reviewing: false,
		countingDown: false,
		completedGameCycles: 0,
		completedPercentage: 0,
		balance: 0,
		actions: {
			killed: 0,
			satisfied: 0,
			unsatisfied: 0,
		},
	},
	actions: {
		initializeCycleBalance(context, payload) {
			let balance = 0;

			payload.breeds.forEach((breedName) => {
				balance += context.rootGetters.breedByName(breedName).food_required;
			});

			context.commit("incrementCycleBalance", { amount: balance });
		},
		startCycle(context) {
			context.commit("setCycleState", { active: true });
			context.commit("addTimer", {
				duration: (context.rootState.config.general.refresh_interval * 1000),
				ref: "cycle",
				action: () => {
					context.dispatch("completeGameCycle").then().then(() => {
						context.dispatch("prepareNextCycle");
					});
				},
			});
		},
		completeGameCycle(context) {
			return new Promise((resolve) => {
				context.commit("setCycleState", { active: false });
				context.commit("incrementGameCycle");
				context.dispatch("reviewCycle");

				if (context.rootState.cats.unfedCount > 0) {
					context.dispatch("playDeadCatFx");
				}

				resolve();
			});
		},
		prepareNextCycle(context) {
			context.commit("compoundCycleBalance", {
				rate: context.rootState.cats.queued.spawn_increase_percentage,
			});
			context.dispatch("cyclicFoodIncrease");
			context.dispatch("prepareCatQueue");
		},
		endCycle(context) {
			// force an update of time remaining
			const index = context.getters.timerIndexByRef("cycle");
			context.commit("updateTimeRemaining", { index });

			context.commit("setCompletionPercentage", {
				percentage: context.getters.cyclePercentageRemaining,
			});

			context.dispatch("completeTimer", {
				timer: context.getters.timerByRef("cycle"),
			});
		},
		reviewCycle(context) {
			context.commit("setReviewState", { reviewing: true });
		},
		completeReview(context) {
			context.commit("setReviewState", { reviewing: false });
			context.commit("resetCycleActions");
			context.commit("setCompletionPercentage", { percentage: 0 });
		},
	},
	mutations: {
		setCycleState(state, payload) {
			state.active = payload.active;
		},
		incrementGameCycle(state) {
			state.completedGameCycles += 1;
		},
		incrementCycleAction(state, payload) {
			state.actions[payload.type] += 1;
		},
		setReviewState(state, payload) {
			state.reviewing = payload.reviewing;
		},
		resetCycleActions(state) {
			Object.keys(state.actions).forEach((actionType) => {
				state.actions[actionType] = 0;
			});
		},
		incrementCycleBalance(state, payload) {
			state.balance += payload.amount;
		},
		compoundCycleBalance(state, payload) {
			const balance = precisionRound(state.balance * (1 + payload.rate), 2);
			state.balance = balance;
		},
		activateCycleCountdown(state) {
			state.countingDown = true;
		},
		deactivateCycleCountdown(state) {
			state.countingDown = false;
		},
		setCompletionPercentage(state, payload) {
			state.completedPercentage = payload.percentage;
		},
	},
	getters: {
		cycleExists(state, getters, rootState, rootGetters) {
			return rootGetters.timerExists("cycle");
		},
		cyclePercentageRemaining(state, getters, rootState, rootGetters) {
			let timeRemaining = 0;

			const timer = rootGetters.timerByRef("cycle");

			if (timer) {
				timeRemaining = timer.timeRemaining / timer.duration;
			}

			return timeRemaining;
		},
	},
};



// WEBPACK FOOTER //
// ./src/store/cycle.js